<template>
  <div class="row" >
    <div class="footer-contain Regular"  ref="footerContain">
      <div class="col-xs-12 col-sm-12 col-md-12 padLR-20 ">
        <div class="footer-top">
          <div class="footer-title pad-0 col-xs-12 col-sm-4 col-md-3 col-md-offset-1">
            <div class="logoMip logoMipJia pointer" v-on:click="navTo('home','Online Magazine')">
              <img src="../images/logo.png" alt="talent.gov.hk Logo" />
            </div>
          </div>
          <div class="footer-list col-xs-12 col-sm-6 col-md-8 col-lg-6" :class="{'item-table':$store.state.innerWidth<=768}">
            <div class="footer-column tdcell" > 
              <div class="footer-column-every">
                <a href="javascript:;" style="color: inherit">
                  <span v-on:click="navTo('magazine','Online Magazine')">{{ $t(("message.Online Magazine")) }}</span>
                </a>
              </div>
              <div class="footer-column-every">
                <a href="javascript:;" style="color: inherit">
                  <span v-on:click="navTo('browseOccupations','Browse Occupations')">{{ $t(("message.Browse Occupations")) }}</span>
                </a>
              </div>
              <div class="footer-column-every">
                <a href="javascript:;" style="color: inherit">
                  <span v-on:click="navTo('findAnOpportunity','Find A Job Opportunity')">{{ $t(("message.Find a Job Opportunity")) }}</span>
                </a>
              </div>
              <div class="footer-column-every">
                <a href="javascript:;" style="color: inherit">
                  <span v-on:click="navTo('browseCourses','Browse Courses')">{{ $t(("message.Browse Courses")) }}</span>
                </a>
              </div>
              <div class="footer-column-every">
                <a href="javascript:;" style="color: inherit">
                  <span v-on:click="navTo('selfAssessment','Self Assessment')">{{ $t(("message.Self-Assessment")) }}</span>
                </a>
              </div>
            </div>


            <div class="footer-column tdcell">
              <div class="footer-column-every">
                <a href="javascript:;" style="color: inherit">
                  <span v-on:click="navTo('aboutUs','About Us')">{{ $t(("message.About Us")) }}</span>
                </a>
              </div>

              <div class="footer-column-every">
                <a href="javascript:;" style="color: inherit">
                  <span v-on:click="navTo('resources','Resources')">{{ $t(("message.Resources")) }}</span>
                </a>
              </div>

              <div class="footer-column-every">
                <a href="javascript:;" style="color: inherit">
                  <span v-on:click="navTo('privacyPolicy','Privacy Policy')">{{ $t(("message.Privacy Policy")) }}</span>
                </a>
              </div>

              <div class="footer-column-every">
                <a href="javascript:;" style="color: inherit">
                  <span v-on:click="navTo('disclaimer','Disclaimer')">{{ $t(("message.Disclaimer")) }}</span>
                </a>
              </div>

              <div class="footer-column-every">
                <a href="javascript:;" style="color: inherit">
                  <span v-on:click="navTo('feedback','Feedback')">{{ $t(("message.Feedback")) }}</span>
                </a>
              </div>

              <div class="footer-column-every">
                <a href="javascript:;" style="color: inherit">
                  <span v-on:click="navTo('siteMap','Site Map')">{{ $t(("message.siteMap")) }}</span>
                </a>
              </div>
            </div>
            <div class="footer-all-icon" v-if="$store.state.innerWidth>992">
              <div class="footer-item-icon">
                <a href="https://www.facebook.com/hkexplorer.talent/" target="_Blank">
                  <i class="icon-facebook"></i>
                </a>
              </div>
              <div class="footer-item-icon">
            
                <a href="https://www.instagram.com/talent.gov.hk/" target="_Blank">
                    <i class="icon-icon-svg-28"></i>
                </a>
              </div>
              <div class="footer-item-icon">
                <a href="https://www.linkedin.com/company/talent-gov-hk/" target="_Blank">
                  <i class="icon-in"></i>
                </a>
              </div>
            
            </div>
          </div>
          <div class="footer-link">
            <div>
              <a href="">
                <img src="" alt="">
              </a>
            </div>
          </div>
        </div>
        <a class="displayA" v-bind:href="'./magazine?lang='+$store.state.language"></a>
        <a class="displayA" v-bind:href="'./browseOccupations?lang='+$store.state.language"></a>
        <a class="displayA" v-bind:href="'./findAnOpportunity?lang='+$store.state.language"></a>
        <a class="displayA" v-bind:href="'./browseCourses?lang='+$store.state.language"></a>
        <a class="displayA" v-bind:href="'./selfAssessment?lang='+$store.state.language"></a>
        <a class="displayA" v-bind:href="'./aboutUs?lang='+$store.state.language"></a>
        <a class="displayA" v-bind:href="'./resources?lang='+$store.state.language"></a>
        <a class="displayA" v-bind:href="'./privacyPolicy?lang='+$store.state.language"></a>
        <a class="displayA" v-bind:href="'./disclaimer?lang='+$store.state.language"></a>
        <a class="displayA" v-bind:href="'./feedback?lang='+$store.state.language"></a>
        <a class="displayA" v-bind:href="'./siteMap?lang='+$store.state.language"></a>
        <a class="displayA" href="./home?lang=en_US"></a>
        <a class="displayA" href="./home?lang=zh_HK"></a>
        <a class="displayA" href="./home?lang=zh_CN"></a>
      </div>
        <div
          class="footer-bottom col-xs-12 col-sm-12 col-md-11 col-md-offset-1"
        >© {{year}}{{$t('message.© 2019')}}</div>
    
    </div>
      <div class="footer-placeImg">
        <div class="footer-box-sheetImg">
          <img class="footer-sheetImg" draggable="false" src="@/images/Group 3.png" alt />
        </div>
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      HList: [
        "Online Magazine",
        "Browse Occupations",
        "Find A Job Opportunity",
        "Browse",
        "Self-Assessment"
      ],
      OthersList: [
        "Resources",
        "Feedback",
        "About Us",
        "site map",
        "Privacy Policy",
        "Disclaimar"
      ],
      noTitle: [],
      year:2020,
    };
  },
  props: ["logGaEvent"],
  mounted() {
    this.navTo = function(path, name) {
      if(this.$store.state.isPreview) return;
      this.logGaEvent("userClick", "footer", name);
       
      this.$router.push({
          path:"/" + path,
          query:{lang:this.$store.state.language}
      })
       window.scrollTo(0,0);
      // body...
    };
    this.year = new Date().getFullYear()
  }
};
</script>